import React from 'react';
import classNames from 'classnames';
import { ExternalLink } from '../../components';

import css from './ListingPage.module.css';

const InfoLink = ({ href, label, icon: Icon, className, onClick }) => {
  if (!href || !label) return null;

  return (
    <ExternalLink href={href} onClick={onClick} className={classNames(css.locationLink, className)}>
      {Icon ? <Icon /> : null}
      {label}
    </ExternalLink>
  );
};

export default InfoLink;
